import { pageLanguage } from './pageLanguage';

export default pageLanguage;
